module.exports = __webpack_public_path__ + "img/luis_pena.59d0e2a2.jpg";